import React from 'react';
import PropTypes from 'prop-types';
import CssClassMixin from '../../../mixins/css_class_mixin.jsx';

var createClass = require('create-react-class');

window.InputAutocompleteResult = createClass({
  mixins: [CssClassMixin],
  propTypes: {
    id: PropTypes.string,
    options: PropTypes.array,
    selectedOptions: PropTypes.array,
    active: PropTypes.number,
    searchValue: PropTypes.string,
    actionButtons: PropTypes.array,
    onKeyDown: PropTypes.func,
    onChange: PropTypes.func,
    onSelect: PropTypes.func,
    onClear: PropTypes.func,
    onOptionMouseEnter: PropTypes.func
  },

  getDefaultProps: function() {
    return {
      themeClassKey: 'input.autocomplete.result',
      options: [],
      selectedOptions: []
    };
  },

  render: function() {
    return (
      <div className={this.className()}>
        {this.renderSearchInput()}
        {this.renderClearButton()}
        {this.renderResult()}
        {this.renderActionButtons()}
      </div>
    );
  },

  renderSearchInput: function() {
    return (
      <div className="input-autocomplete__search">
        <Icon type="search" className="prefix" />
        <InputText
          onKeyDown={this.props.onKeyDown}
          value={this.props.searchValue}
          onChange={this.props.onChange}
          autoComplete="off"
        />
      </div>
    );
  },

  renderClearButton: function() {
    return (
      <a href="#!"
         className="input-autocomplete__clear-button"
         onClick={this.props.onClear}>

        {Realize.i18n.t("inputs.autocomplete.clear")}
      </a>
    );
  },

  renderResult: function() {
    var options = this.props.options;
    if(options.length > 0) {
      return this.renderList();
    } else {
      return this.renderEmptyMessage();
    }
  },

  renderList: function() {
    return (
      <InputAutocompleteList
        id={this.props.id}
        selectedOptions={this.props.selectedOptions}
        options={this.props.options}
        active={this.props.active}
        onSelect={this.props.onSelect}
        onOptionMouseEnter={this.props.onOptionMouseEnter}
        ref="list"
      />
    );
  },

  renderEmptyMessage: function() {
    return (
      <div className="input-autocomplete__empty-message">
        {Realize.i18n.t("inputs.autocomplete.emptyResult")}
      </div>
    );
  },

  renderActionButtons: function() {
    var actionButtons = [];
    var actionButtonsProps = this.props.actionButtons;

    for(var i = 0; i < actionButtonsProps.length; i++) {
      var actionButtonProps = actionButtonsProps[i];
      actionButtons.push(this.renderActionButton(actionButtonProps, i));
    }

    return (
      <div className="input-autocomplete__action-buttons">
        {actionButtons}
      </div>
    );
  },

  renderActionButton: function(actionButtonProps, i) {
    var buttonComponent = (actionButtonProps.component || 'Button');
    var buttonProps = React.__spread({}, actionButtonProps, {
      themeClassKey: 'input.autocomplete.actionButton',
      element: "a",
      key: ("action_" + i)
    });

    return React.createElement(eval(buttonComponent), buttonProps);
  }
});